<template>
  <button
    type="button"
    tabindex="0"
    role="menuitem"
    class="menu-item"
  >
    <busy-area :busy="busy">
      <component :is="icon" class="max-w-7 max-h-7 w-full h-full" />
    </busy-area>
    <span class="text-pane-label">{{ label }}</span>
  </button>
</template>

<script lang="ts" setup>
import type { VueInstance } from '@vueuse/core';
import type { FunctionalComponent } from 'vue';
import BusyArea from '@utils/busy/BusyArea.vue';

interface Props {
  label: string;
  icon: VueInstance | FunctionalComponent;
  busy?: boolean;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
.menu-item {
  @apply flex flex-col items-center gap-y-1;
  @apply px-3 py-3.5 cursor-pointer;
  @apply hover:bg-info-blue-10 hover:text-info-blue;
  @apply transition-colors;
  @apply font-normal text-dark;

  width: var(--menu-width);

  &.active {
    @apply text-pane-label-active;
    @apply bg-info-blue-10 text-info-blue;

    :deep(svg path) {
      @apply fill-info-blue;
    }
  }

  :deep(svg path) {
    @apply transition-all;
  }

  &:hover :deep(svg path) {
    @apply fill-info-blue;
  }
}
</style>
